module.exports = __webpack_public_path__ + "img/antes_despues_81.4d5ee9c8.png";